import {
  SR_API_ACTION_AGENT_GET_LEADERBOARD,
} from 'api/actionTypes';

export default async function getLeaderboard({ state, apiClient }, { startDate, endDate }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_AGENT_GET_LEADERBOARD,
    state: state,
    payload: {
      startDate,
      endDate,
    },
    onSuccess(leaderboard) {
      state.set(['agent', 'leaderboard'], leaderboard);
    },
  });
}
